import React, { useEffect, useState } from 'react';
import { Container } from 'reactstrap';
import DriverDetails from './components/DriverDetails';
import DriverModal from '../AddOrUpdate/components/ModalDriver';
import PndApi from '../../../../utils/pnd/PndRestApi';
import LinearProgress from '@mui/material/LinearProgress';
import { Box } from '@mui/material';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import { showNotification, successNofication } from 'src/shared/components/Notification';
import PndRestApi from '../../../../utils/pnd/PndRestApi';
import ConfirmationDialog from 'src/shared/components/ConfirmationDialog';
import { ERROR_MESSAGES } from 'src/utils/pnd/PndConstants';
import PageHeader from 'src/shared/components/layout/PageHeader';

const DriverDetailsIndex = () => {
  useEffect(() => {
    getAllDriverDetails();
  }, [])

  const [reactTableData, setReactTableData] = useState([]);
  const [temp, setTempData] = useState("");
  const [viewDetailPopup, setViewDetailPopup] = useState(false);
  const [isTitle, setTitle] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isDeleteData, setDeleteData] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showUnlockConfirmation, setShowUnlockConfirmation] = useState(false);
  const [isNoRecordFound, setNoRecordFound] = useState(false);
  const [isRedirect, setRedirect] = useState(false);
  const [isUnlockRiderId, setUnlockRiderId] = useState(null);

  const getAllDriverDetails = async () => {
    try {
      setLoading(true);
      const response = await PndApi.GetAllDriver();
      if (response.status === 200 && response.data.status === 200) {
        setReactTableData({ tableRowsData: response.data.data });
      } else if (response?.data?.status && response?.data?.status === 204) {
        setNoRecordFound(true);
      }
      else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:${response.data.message}`,
        );
        return;
      }

    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    } finally {
      setLoading(false);
    }
  };

  const deletePermanently = async (rowData) => {
    if (rowData?.driverId) {
      setShowConfirmation(true); // Show confirmation dialog
      setDeleteData(rowData); // Store data for deletion
    }
  };

  const handleConfirmDelete = async () => {
    try {
      let obj = {};
      obj["driverId"] = isDeleteData.driverId;
      const response = await PndRestApi.DeleteDriverDetails(obj);
      if (response.status === 200 && response.data.status === 200) {
        successNofication(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message: Rider Details Deleted from the Hub`
        );
        setRedirect(true);
      } else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:${response.data.message}`,
        );
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
        "theme-light",
        "ltr",
        `Message: Operation Failed due to some reason. Please try again`
      );
    } finally {
      // Close confirmation dialog
      setShowConfirmation(false);
    }
  };

  if (isRedirect) {
    window.location.reload();
  }

  const handleCancelUnassign = () => {
    // Close confirmation dialog without performing deletion
    setShowConfirmation(false);
  };

  const unlockUser = async () => {
    try {
      const response = await PndRestApi.UnlockedRiderAccount(isUnlockRiderId);
      if (response.status === 200 && response.data.status === 200) {
        successNofication(
          "theme-light",
          "ltr",
          `Message: Rider's account unlocked successfully.`
        );
        setRedirect(true);
      } else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:${response.data.message}`,
        );
        return;
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    }
  };

  const closeUnlockDialog = () => {
    // Close confirmation dialog
    setShowUnlockConfirmation(false);
  };

  const showUnlockDialog = async (event) => {
    if (event) {
      setShowUnlockConfirmation(true);
      setUnlockRiderId(event?.riderId);
    }
  }

  const add = () => {
    setTempData(null);
    setViewDetailPopup(true);
    setTitle("Add Driver");
  };

  const edit = async (event) => {
    if (event.driverId) {
      setTempData(event);
      setViewDetailPopup(true);
      setTitle("Edit - Driver Details")
    }
  }

  return (
    <Box sx={{ p: 3, backgroundColor: '#f8fafc', minHeight: '100vh' }}>
      <Container fluid style={{ maxWidth: '1400px' }}>
        <PageHeader
          icon={<DirectionsCarIcon fontSize="large" />}
          title="Driver Management"
          subtitle="Manage driver profiles, hub allocations, and vehicle mappings. After the driver information is saved, assign driver using Manage hub button."
          gradient="linear-gradient(135deg, #10b981 0%, #059669 100%)"
        />

        {loading && <LinearProgress sx={{ mb: 2, borderRadius: 2 }} />}

        <Box sx={{ position: 'relative' }}>
          {(reactTableData && reactTableData != null && reactTableData.tableRowsData != null) && !isNoRecordFound && (
            <DriverDetails
              reactTableData={reactTableData}
              setRedirect={setRedirect}
              onAdd={add}
              onEdit={edit}
              onDelete={deletePermanently}
              onUnlock={showUnlockDialog}
            />
          )}
          {isNoRecordFound && (
            <DriverDetails
              isNoRecordFound={isNoRecordFound}
              setRedirect={setRedirect}
              onAdd={add}
              onEdit={edit}
              onDelete={deletePermanently}
              onUnlock={showUnlockDialog}
            />
          )}
          {/* {isNoRecordFound && <SnackbarContent message={"No Record Found"} />} */}
        </Box>

        {viewDetailPopup &&
          <DriverModal
            modalShow={viewDetailPopup}
            setModalShow={setViewDetailPopup}
            hubData={temp}
            isTitle={isTitle}
          />}

        {showConfirmation && (
          <ConfirmationDialog
            open={showConfirmation}
            onClose={handleCancelUnassign}
            onConfirm={handleConfirmDelete}
            title="Confirmation"
            message="Are you sure you want to permanently delete the driver?"
          />
        )}

        {showUnlockConfirmation && (
          <ConfirmationDialog
            open={showUnlockConfirmation}
            onClose={closeUnlockDialog}
            onConfirm={() => unlockUser()}
            title="Confirmation"
            message="Are you sure, Do you want to proceed?"
          />
        )}
      </Container>
    </Box>
  );
};

export default DriverDetailsIndex;